(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    root.querySelectorAll('.section-header header-menu details, .section-header .desktop-localization-wrapper .disclosure:has(.language-selector)').forEach((region) => {
      if (region.dataset.csNavigation) return;
      region.dataset.csNavigation = 'true';
      const isDetails = region.tagName === 'DETAILS';
      const trigger = isDetails ? region.querySelector(':scope > summary') : region.querySelector('button');
      const panel = isDetails ? trigger.nextElementSibling : region.querySelector('.language-selector');
      const isMainMenu = isDetails && region.parentElement.tagName === 'HEADER-MENU';
      const header = isMainMenu ? region.closest('.header-wrapper') : null;
      let closeTimer;
      let motion;
      let requestedOpen = false;
      const applyOpen = (open) => {
        if (isDetails) region.open = open;
        else panel.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
      };
      const updateGeometry = () => {
        if (!isMainMenu || !desktop.matches) return;
        const headerBounds = header.getBoundingClientRect();
        const triggerBounds = trigger.getBoundingClientRect();
        trigger.style.setProperty('--cs-header-hover-bridge', `${Math.max(0, headerBounds.bottom - triggerBounds.bottom) + 2}px`);
        panel.style.setProperty('--cs-header-submenu-start', `${Math.max(0, triggerBounds.left - headerBounds.left)}px`);
        const pageStyle = window.getComputedStyle(document.body);
        panel.style.setProperty('--cs-header-page-background', pageStyle.getPropertyValue('--gradient-background').trim() || `rgb(${pageStyle.getPropertyValue('--color-background').trim()})`);
      };
      if (isMainMenu) {
        updateGeometry();
        const observer = new ResizeObserver(() => {
          if (!region.isConnected) return observer.disconnect();
          updateGeometry();
        });
        observer.observe(header);
        observer.observe(trigger);
      }
      const setOpen = (open) => {
        clearTimeout(closeTimer);
        const wasOpen = isDetails ? region.open : !panel.hidden;
        const wasClosing = !requestedOpen && wasOpen;
        requestedOpen = open;
        if (motion) motion.cancel();
        if (open && isMainMenu && desktop.matches) {
          updateGeometry();
          header.querySelectorAll('header-menu > details[open]').forEach((other) => {
            if (other === region) return;
            other.dispatchEvent(new Event('cs-navigation-close'));
          });
        }
        if (!desktop.matches || reducedMotion.matches || (!open && !wasOpen)) {
          applyOpen(open);
          return;
        }
        if (open) {
          applyOpen(true);
          if (wasOpen && !wasClosing) return;
        }
        motion = panel.animate(
          open
            ? [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }]
            : [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-4px)' }],
          { duration: open ? 300 : 240, easing: open ? 'ease-out' : 'ease-in-out', fill: 'both' }
        );
        const currentMotion = motion;
        currentMotion.finished.then(() => {
          if (motion !== currentMotion) return;
          if (!requestedOpen) applyOpen(false);
          currentMotion.cancel();
          motion = null;
        }).catch(() => {});
      };
      region.addEventListener('cs-navigation-close', () => {
        clearTimeout(closeTimer);
        requestedOpen = false;
        if (motion) motion.cancel();
        motion = null;
        applyOpen(false);
      });
      if (isMainMenu) trigger.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        event.preventDefault();
        setOpen(!region.open || !requestedOpen);
      });
      region.addEventListener('pointerenter', (event) => {
        if (desktop.matches && hover.matches && event.pointerType === 'mouse') setOpen(true);
      });
      region.addEventListener('pointerleave', (event) => {
        if (desktop.matches && hover.matches && event.pointerType === 'mouse' && !region.contains(document.activeElement)) {
          closeTimer = setTimeout(() => setOpen(false), 200);
        }
      });
      region.addEventListener('focusin', (event) => {
        if (desktop.matches && event.target === trigger && trigger.matches(':focus-visible')) setOpen(true);
      });
      region.addEventListener('focusout', (event) => {
        if (desktop.matches) event.stopImmediatePropagation();
        requestAnimationFrame(() => {
          if (desktop.matches && !region.contains(document.activeElement) && !region.matches(':hover')) setOpen(false);
        });
      }, true);
      region.addEventListener('keyup', (event) => {
        if (desktop.matches && event.key === 'Escape') {
          event.stopImmediatePropagation();
          setOpen(false);
          trigger.focus();
          setOpen(false);
          event.stopPropagation();
        }
      }, true);
      if (isDetails) region.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(region.open));
        if (region.open) updateGeometry();
      });
      desktop.addEventListener('change', () => setOpen(false));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
